module.exports = __webpack_public_path__ + "static/media/CreatingOrderIllustration.57b73930.svg";